<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="col-md-6 offset-md-3">
            <h5 class="card-title center">Agregar Rol</h5>
            <form>
              <div class="form-group row">
                <label for="inputRoleName" class="col-sm-2 col-form-label">Rol</label>
                <div class="col-sm-10">
                  <input type="text" :disabled="showSpiner" class="form-control" id="inputRoleName" v-model="input.roleName">
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-6 offset-md-3 center" v-if="showSpiner">
            <font-awesome-icon :icon="['fal', 'spinner']" size="6x" spin />
            <h6 class="mt-3">Cargando los modulos y permisos...</h6>
          </div>
          <div class="col-md-12" role="tablist" v-for="mod in modulePermissions.modules" :key="mod.admin_module_id">
            <div class="card mb-1">
              <div class="card-header" role="tab" v-b-toggle="`module-${mod.admin_module_id}`">
                Permisos Modulo {{ mod.module_label }}
              </div>
              <b-collapse visible :id="`module-${mod.admin_module_id}`" role="tabpanel">
                <div class="card-body">
                  <b-table
                    selectedVariant="success"
                    show-empty
                    stacked="md"
                    :fixed="true"
                    :borderless="true"
                    :items="modulePermissions.permissions[mod.admin_module_id]"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                  >
                    <template v-slot:cell(actions)="row">
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="`admin_permission_id_${row.item.admin_permission_id}`"
                          v-model="input.checkedPermissions"
                          :value="row.item.admin_permission_id"
                        >
                        <label
                          class="custom-control-label"
                          :for="`admin_permission_id_${row.item.admin_permission_id}`">
                            {{ input.checkedPermissions.indexOf(row.item.admin_permission_id) !== -1 ? 'activo' : 'inactivo' }}
                        </label>
                      </div>
                    </template>
                  </b-table>
                </div>
              </b-collapse>
            </div>
          </div>
          <div class="col-md-6 offset-md-3">
            <div class="form-group row">
                <div class="col-sm-12 mt-5">
                  <button type="button" :disabled="showSpiner" class="btn btn-primary btn-block" @click="registerNewRole">Registrar</button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCollapse, BTable } from 'bootstrap-vue'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [formatData],
  components: {
    BCollapse,
    BTable
  },
  data () {
    return {
      input: {
        roleName: '',
        checkedPermissions: []
      },
      modulePermissions: {},
      fields: [
        { key: 'subject', label: 'Modulo' },
        { key: 'description', label: 'Descripcion' },
        { key: 'conditions', label: 'Condiciones' },
        { key: 'actions', label: 'Acciones' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    }
  },
  computed: {
    showSpiner () {
      return this.$_.isEmpty(this.modulePermissions)
    }
  },
  methods: {
    async registerNewRole () {
      try {
        const request = {
          ...this.input
        }
        // const params = await this.toFormData(request)
        const response = await axiosAdelaService.post('/addRole', request)
        console.log('add', response)
        if (response.status === 200) {
          this.$toastedPush({
            message: 'Se agrego el nuevo role.',
            type: 'success'
          })
          this.$router.push({ name: 'roles' })
        }
      } catch (error) {
        this.showError('No se pudo agregar el role, intentalo mas tarde')
      }
    }
  },
  async mounted () {
    try {
      const modulePermissionsResponse = await axiosAdelaService.post('/getModulesPermissions')
      if (modulePermissionsResponse.status === 200) {
        this.modulePermissions = modulePermissionsResponse.data
      }
    } catch (error) {
      this.showError('No se pudieron obtener los datos intentalo mas tarde.')
    }
  }
}
</script>

<style>

</style>
